import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh = {
    login: {
        'loginTitle': '欢迎登录',
        'loginForget': '忘记密码',
        'username': '请输入用户名',
        'password': '请输入密码',
        'email': '请输入邮箱',
        'CAPTCHA': '请输入验证码',
        'change': '换一张',
        'remember': '记住我',
        'forget': '忘记密码',
        'loginOn': '去登录',
        'login': '登录平台',
        'loginIn': '登 录 中...',
        'retrieve': '立即找回',
        'retrieving': '找 回 中...',
        'simulation': '虚拟仿真实验室',
        'dimension': '/让教育多一个维度',
        'formusername': '用户名不能为空',
        'formpassword': '密码不能小于5位，且不能为空',
        'formemail': '邮箱不能为空',
        'formCAPTCHA': '验证码不能为空'
    },
    ...zhLocale
}
export default zh;


// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js